module.exports = __webpack_public_path__ + "static/media/skyber.9beb0e23.svg";